import styled from 'styled-components';
import { TextField } from '@mui/material';
import { Colors, Styling } from '../../../../constants';
import { MEDIUM_GREY } from '../../../VirtualClipper/constants/theme';

interface IFormGroupProps {
  disabled?: boolean;
}

export const FormRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: ${Styling.DEFAULT_SPACING}px; 
`;

export const DropContainer = styled.div`
  width: 100%;
  margin: ${Styling.DEFAULT_SPACING}px;
  padding: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  background-color: ${Colors.PAPER_BORDER};
  border: 1px dotted ${Colors.MEDIUM_GREY};
`;

export const DropNotice = styled.h1`
  cursor: default;
  left: 0;
  right: 0;
  font-weight: bolder;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: ${Colors.MEDIUM_GREY};

  svg {
    position: relative;
    top: 4px;
  }
`;

export const Label = styled.h1`
  cursor: default;
  text-align: left;
  font-weight: bolder;
`;

export const FormGroup = styled.div<IFormGroupProps>`
  ${(props) => (props.disabled ? `
    ${Label} {
      color: ${Colors.LIGHT_GREY};
    }
  ` : null)}
`;

export const StyledTextField = styled(TextField)`
  input {
    padding: ${Styling.DEFAULT_SPACING}px !important;
  }
`;

export const SelectedFilesContainer = styled.div`
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 188px;
  overflow-y: auto;
`;

export const SelectedFileContainer = styled.div`
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  display: flex;
  width: 100%;
  align-items: center;
`;

export const SelectedFilesText = styled.span`
  width: 40%;
`;

export const UploadStatusText = styled.span`
  color: ${MEDIUM_GREY};
  padding-left: ${Styling.DEFAULT_SPACING_HALVED}px;
  flex: 1.25;
`;

export const UploadStatusBar = styled.span`
  color: ${MEDIUM_GREY};
  padding-left: ${Styling.DEFAULT_SPACING_HALVED}px;
  flex: 2;
`;
